import { cva, type VariantProps } from 'class-variance-authority';

export const notificationVariants = cva(
  'relative flex w-full items-center justify-center overflow-auto break-words rounded-[10px] px-5 py-2.5 text-md font-normal leading-4.5',
  {
    variants: {
      variant: {
        success: 'bg-green-500 text-white',
        error: 'bg-red-500 text-white',
        custom: 'bg-slate-400',
      },
    },
    defaultVariants: {
      variant: 'success',
    },
  },
);

export type NotificationVariantProps = VariantProps<
  typeof notificationVariants
>;
